import Slider from 'react-slick';
import { chakra, Box } from '@stockx/ui';

export const CarouselWrapper = chakra(Box, {
  baseStyle: {
    mx: 'auto',
    px: [0, 0, 0, 12],
    mt: 0,
    minHeight: { base: '219px', lg: '252px' },
  },
  label: 'carousel-wrapper',
});

const ButtonBaseStyles = {
  pos: 'absolute',
  top: 'calc(50% - 1.25rem)',
  display: ['none', 'none', 'none', 'inline-flex'],
  background: 'neutral.black',
  borderRadius: '100%',
  _hover: {
    background: 'neutral.black',
  },
};

const BigButtonBaseStyles = {
  ...ButtonBaseStyles,
  zIndex: 3,
  display: { base: 'none', xl: 'inline-flex' },
  top: 'calc(50% - 1.25rem)',
  transform: 'scale(1.25)',
  '&:disabled': {
    display: 'none',
  },
};

export const ButtonStyles = {
  right: {
    ...ButtonBaseStyles,
    right: '-3rem',
  },
  left: {
    ...ButtonBaseStyles,
    left: '-3rem',
  },
};

export const BigButtonStyles = {
  right: {
    ...BigButtonBaseStyles,
    right: '-1rem',
    svg: {
      transform: 'scale(1.75)',
      marginLeft: '0.125rem',
    },
  },
  left: {
    ...BigButtonBaseStyles,
    left: '-1rem',
    svg: {
      transform: 'scale(1.75)',
      marginRight: '0.125rem',
    },
  },
};

export const StyledCarousel = chakra(Slider, {
  baseStyle: {
    position: 'relative',
    'button.slick-arrow.slick-prev': {
      display: 'none !important',
    },
    'button.slick-arrow.slick-next': {
      display: 'none !important',
    },

    '.slick-list': {
      overflow: 'hidden',
      overflowX: { base: 'scroll', md: 'hidden' },

      '::-webkit-scrollbar': {
        width: ['0px', 'auto', 'auto'],
        background: ['transparent', 'inherit', 'inherit'],
      },

      msTouchAction: { base: 'auto', md: 'none' },
      touchAction: { base: 'auto', md: 'none' },
    },

    '.slick-track': {
      display: 'flex',
      flexDirection: 'row',
    },

    '.slick-slide': {
      width: '100% !important',
    },
  },
});
